// extracted by mini-css-extract-plugin
export default {"hud":"HUD_hud__XjuSB","hudBox":"HUD_hudBox__aqx4I","hudActions":"HUD_hudActions__vP49c"};